import _ from 'underscore'
import React from 'react'
import { Calendar, LoaderCircle } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import ScheduledCallsPartial from './partial'

class ScheduledCalls extends React.Component {

  onOpenChange = (open) => {
    if (open) {
      this.props.store.emit('scheduled_calls:index')
      this.props.store.get().ui.scheduled_calls.set({ open: true })
    }
    else {
      this.props.store.get().ui.scheduled_calls.set({ open: false })
    }
  }

  onRefresh = () => {
    this.props.store.emit('scheduled_calls:index')
  }

  onSubscribe = (e) => {
    e.preventDefault()
    this.props.store.emit('scheduled_calls:subscribe', !this.props.ui.subscribed)
  }

  render() {
    const count = this.props.scheduled_calls.length

    return (
      <Popover open={this.props.ui.open} onOpenChange={this.onOpenChange}>
        <PopoverTrigger asChild>
          <button
            type="button"
            aria-label="Scheduled Calls"
            title="Scheduled Calls"
            className="relative flex size-9 shrink-0 items-center justify-center rounded-xl text-foreground/80 outline-hidden transition-colors hover:bg-accent hover:text-foreground data-[state=open]:bg-accent data-[state=open]:text-foreground"
          >
            <Calendar className="size-4" />
            {count > 0 ?
              <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-semibold leading-none text-white">
                {count > 99 ? '99+' : count}
              </span>
              : null
            }
          </button>
        </PopoverTrigger>
        <PopoverContent
          side="bottom"
          align="end"
          sideOffset={8}
          className="w-[650px] max-w-[calc(100vw-2rem)] overflow-hidden p-0"
        >
          <Tabs value="calls" className="gap-0">
            <TabsList variant="line" className="px-2 pt-2">
              <TabsTrigger value="calls" onClick={this.onRefresh}>Scheduled Calls</TabsTrigger>
            </TabsList>
          </Tabs>
          <div className="max-h-[60vh] overflow-y-auto border-t">
            {this.props.ui.loading ?
              <div className="flex justify-center py-12">
                <LoaderCircle className="size-10 animate-spin text-muted-foreground" />
              </div>
              :
              _.map(this.props.scheduled_calls, (scheduled_call) => {
                return (
                  <ScheduledCallsPartial
                    key={scheduled_call.id}
                    scheduled_call={scheduled_call}
                    store={this.props.store}
                  />
                )
              })
            }
          </div>
          {(!this.props.ui.loading) ?
            <div className="border-t px-4 py-2 text-center">
              <a href="#" className="text-sm text-primary no-underline hover:underline" onClick={this.onSubscribe}>
                {(this.props.ui.subscribed) ?
                  <span>Turn off reminders</span>
                  :
                  <span>Turn on reminders</span>
                }
              </a>
            </div>
            : null
          }
        </PopoverContent>
      </Popover>
    )
  }
}

export default ScheduledCalls
